<template>
  <div class="content-tab firmware-update">
    <div class="content-body">
      <div class="table-row">
        <div class="title">{{$t('overview.modelname')}}</div>
        <div :title="sysBoard.Product" class="value" v-if="fwinfo">{{sysBoard.Product}}</div>
      </div>
      <div class="table-row">
        <div class="title">{{$t('updatefw.fwVersion')}}</div>
        <div :title="fwinfo.version+'.'+fwinfo.number" class="value" v-if="fwinfo">{{fwinfo.version+'.'+fwinfo.number}}</div>
      </div>
      <div class="table-row">
        <div class="title">{{$t('updatefw.date')}}</div>
        <div :title="fwinfo.date" class="value" v-if="fwinfo">{{fwinfo.date}}</div>
      </div>
      <div class="table-row">
        <div class="title">{{$t('updatefw.systemuptime')}}</div>
        <div :title="UpTime" class="value" v-if="displayTime">{{displayTime}}</div>
      </div>
      <div class="table-row input-file">
        <input name="ID" class="form-control file-input" :placeholder="$t('updatefw.selectfile')" v-model="filename" type="text" readonly>
        <div class="input-btn">
          <div class="q-button update-btn" :title="$t('updatefw.browse')" @click="onBrowseClick">
            <folder class="q-icon"/>
            <div class="title">{{$t('updatefw.browse')}}</div>
          </div>
          <input type="file" name="file" class="choose-file" id="choose-file" ref="choose" @change="getFileValue" />
        </div>
        <button class="q-button" type="submit" :title="$t('updatefw.updatesystem')" :disabled="!enableUpdateBtn" @click="onUpdateClick">{{$t('updatefw.updatesystem')}}</button>
      </div>
    </div>
    <popup-confirm name="firmware-modal" :dialog-header="$t('updatefw.updatesystem')" :dialog-message="$t('updatefw.localUpdateContent')" icon="w" type="u" :callback="goUpdate" />
    <popup-confirm :selHeight="160" name="warn-modal" :dialog-header="$t('updatefw.updateFail')" :onlyOk=true />
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import folder from '../assets/svg/folder.svg'
export default {
  name: 'fm-update',
  components: {
    folder
  },
  data () {
    return {
      UpTime: null,
      enableUpdateBtn: false,
      filename: null
    }
  },
  mounted () {
    this.getInfo()
  },
  created: async function () {
    let me = this
    window.addEventListener('beforeunload', function (e) {
      me.firmwareUpdateExit()
    })
  },
  methods: {
    ...mapActions(['getSystemUptime', 'getSystemInfo', 'postLocalUpload', 'getSystemTime', 'postLocalChunkUpload', 'firmwareUpdateExit']),
    ...mapMutations(['openModal', 'closeModal']),
    getInfo () {
      this.getSystemUptime()
        .then((res) => {
          if (res.data && res.data.error_code === 200) {
            this.UpTime = res.data.result.UpTime // sec
          }
        })
    },
    getFileValue (event) {
      if (document.getElementById('choose-file').files.length > 0) {
        this.filename = document.getElementById('choose-file').files[0].name
        let tempFile = this.filename.split('.')
        let expandType = null
        tempFile[tempFile.length - 1] === 'img' ? expandType = true : expandType = false
        if (tempFile && expandType) {
          this.enableUpdateBtn = true
        } else {
          this.enableUpdateBtn = false
        }
      } else {
        this.filename = this.$t('updatefw.selectfile')
        this.enableUpdateBtn = false
      }
    },
    onBrowseClick () {
      this.$refs.choose.click()
    },
    onUpdateClick () {
      this.getSystemInfo()
        .then((result) => {
          this.$modal.show('firmware-modal')
          this.openModal('firmware-modal')
        })
    },
    goUpdate () {
      this.$modal.hide('firmware-modal')
      this.closeModal('firmware-modal')
      this.$log.info('update click', document.getElementById('choose-file').files[0])
      let file = document.getElementById('choose-file').files[0]
      if (file) {
        let me = this
        let loaded = 1048576
        let step = 1048576 // 1024*1024 bytes
        let total = file.size
        let start = 0
        let reader = new FileReader()
        let blob = file.slice(start, loaded)
        let sessionid = this.makeid()
        reader.readAsBinaryString(blob)
        this.$store.commit('setUpdateStatus', true)
        this.$store.commit('updateFileStatus', false)
        this.$store.commit('setUpdateType', 'local')
        let chunkUpload = function () {
          me.postLocalChunkUpload({data: blob, filesize: total, start: start, loaded: loaded + step, filename: file.name, seesionid: sessionid})
            .then((res) => {
              if (loaded === total) {
                me.$store.commit('updateFileStatus', true)
                me.getSystemTime()
              } else {
                loaded = ((loaded + step) >= total) ? total : loaded + step
                start = start + step
                blob = file.slice(start, loaded)
                reader.readAsBinaryString(blob)
                chunkUpload()
              }
            }).catch((error) => {
              me.$log.info('>>> local update fail.')
              me.$log.error(error)
              me.$store.commit('setUpdateType', '')
              me.$store.commit('setUpdateStatus', false)
              me.$store.commit('updateFileStatus', true)
              if (error.response.status !== 401) {
                me.$modal.show('warn-modal')
                me.openModal('warn-modal')
              }
            })
        }
        chunkUpload()
      }
      // if (file) {
      //   let form = new FormData()
      //   form.append('filesize', file.size)
      //   form.append('file', file)
      //   this.$store.commit('setUpdateStatus', true)
      //   this.$store.commit('updateFileStatus', false)
      //   this.$store.commit('setUpdateType', 'local')
      //   this.postLocalUpload(form)
      //     .then((res) => {
      //       this.$store.commit('updateFileStatus', true)
      //       this.getSystemTime()
      //     }).catch((error) => {
      //       this.$log.info('>>> local update fail.')
      //       this.$log.error(error)
      //       this.$store.commit('setUpdateType', '')
      //       this.$store.commit('setUpdateStatus', false)
      //       this.$store.commit('updateFileStatus', true)
      //       this.$modal.show('warn-modal')
      //       this.openModal('warn-modal')
      //     })
      // }
    },
    makeid: function () {
      let result = ''
      let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let charactersLength = characters.length
      for (let i = 0; i < 6; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    }
  },
  computed: {
    ...mapState({
      sysBoard: state => state.module.sysBoard,
      fwinfo: state => state.module.fwinfo
    }),
    displayTime () {
      let sec = (this.UpTime) ? this.UpTime : '--'
      let time = sec + ' ' + this.$t('timestamp.sec')
      if (sec > 60) {
        var second = parseInt(sec) % 60
        var min = parseInt(sec / 60)
        time = min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
        if (min > 60) {
          min = parseInt(sec / 60) % 60
          var hour = parseInt(parseInt(sec / 60) / 60)
          time = hour + ' ' + this.$t('timestamp.hour') + ' ' + min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
          if (hour > 24) {
            hour = parseInt(parseInt(sec / 60) / 60) % 24
            var day = parseInt(parseInt(parseInt(sec / 60) / 60) / 24)
            time = day + ' ' + this.$t('timestamp.day') + ' ' + hour + ' ' + this.$t('timestamp.hour') + ' ' + min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
          }
        }
      }
      return time
    }
  }
}
</script>

<style lang="scss" scoped>
.content-tab.firmware-update {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-body {
    padding: 20px 20px 0px 20px;
    .table-row {
      padding-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      .title {
        font-family: 'Roboto-M' !important;
        margin-right: 10px;
      }
      &.input-file {
        display: flex;
        .file-input {
          width: 385px;
          margin: 0px;
          background-color: #ffffff;
        }
        .q-button {
          margin-left: 10px;
        }
        .choose-file {
          display: none;
        }
        .update-btn {
          display: flex;
          justify-content: center;
          border-width: 0px;
          color: #ffffff;
          background-image: linear-gradient(180deg, #4E8FE2 0%, #3475C6 97%);
          border-radius: 4px;
          border-radius: 4px;
          &:hover {
            background-image: linear-gradient(180deg, #59A0FA 3%, #3F8DED 94%);
          }
          &:active {
            background: #324EAD;
          }
          &:disabled {
            background: rgba(169,169,169,0.30);
          }
          .title {
            line-height: 20px;
            margin-left: 5px;
            margin-right: 0px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FirmwareUpdate.vue